import React, { useEffect } from "react";
import { useTheme, useMediaQuery, Box, Tabs, Tab } from "@mui/material";
import { useLocation, useNavigate, Outlet, useParams } from "react-router-dom";

export default function StockAnalyzerTabs() {
	const { symbol } = useParams();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const location = useLocation();
	const navigate = useNavigate();

	// Define routes and their respective tab indices
	const tabRoutes = [
		`/stock-analyzer/${symbol}/key-indicators`,
		`/stock-analyzer/${symbol}/financials`,
		`/stock-analyzer/${symbol}/fundamentals`,
		`/stock-analyzer/${symbol}/1`,
		`/stock-analyzer/${symbol}/2`,
		`/stock-analyzer/${symbol}/3`,
		`/stock-analyzer/${symbol}/4`,
	];

	// Determine the current tab based on the URL
	// const currentTab = tabRoutes.indexOf(location.pathname);
	const currentTab = tabRoutes.findIndex((route) =>
		location.pathname.startsWith(route)
	);
	const [value, setValue] = React.useState(
		currentTab !== -1 ? currentTab : false
	);

	useEffect(() => {
		if (currentTab !== value) {
			setValue(currentTab !== -1 ? currentTab : false);
		}
	}, [location.pathname, currentTab, value]);

	const handleChange = (event, newValue) => {
		setValue(newValue);
		navigate(tabRoutes[newValue]); // Navigate programmatically
	};

	const tabSx = {
		textTransform: "none",
		fontWeight: "bold",
		fontSize: isMobile ? ".9rem" : "1rem",
		marginLeft: isMobile ? "0rem" : "0.5rem",
		marginRight: isMobile ? "1rem" : "0.5rem",
		borderRadius: 2,
		paddingRight: isMobile ? 0 : "",
		paddingLeft: isMobile ? 0 : "",
		minWidth: "fit-content",
		//   paddingLeft: isMobile ? '' : '1.5rem',
		//   paddingRight: isMobile ? '' : '1.5rem',
	};

	return (
		<>
			<Box
				sx={{
					// border: '1px dashed grey',
					maxWidth: "100%",
					bgcolor: "background.paper",
					display: "flex",
					justifyContent: "center",
					marginTop: isMobile ? "1.5rem" : "2.5rem",
					marginLeft: "auto",
					marginRight: "auto",
				}}
				// sx={{
				//   display: 'flex',
				//   justifyContent: 'center',
				//   marginTop: '3rem',
				//   marginRight: '1rem',
				//   marginLeft: '1rem',
				//   position: 'relative',
				//   maxWidth: '100%',
				//   overflow: 'hidden',
				//   '&::before, &::after': {
				// 	content: '""',
				// 	position: 'absolute',
				// 	top: 0,
				// 	bottom: 0,
				// 	width: '1rem',
				// 	pointerEvents: 'none',
				// 	zIndex: 1,
				//   },
				//   '&::before': {
				// 	left: 0,
				// 	background: 'linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))',
				//   },
				//   '&::after': {
				// 	right: 0,
				// 	background: 'linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))',
				//   },
				// }}
			>
				<Tabs
					value={value}
					onChange={handleChange}
					variant="scrollable"
					scrollButtons="auto"
					// allowScrollButtonsMobile
					aria-label="stock info tabs"
					sx={{
						paddingLeft: isMobile ? "0.5rem" : "",
						paddingRight: isMobile ? "0.5rem" : "",
						// borderBottom: isMobile ? "0.1px solid gray" : "",
						[`& .MuiTabs-scrollButtons`]: {
							"&.Mui-disabled": { opacity: 0.2 },
						},
						"& .MuiTabs-indicator": {
							borderRadius: 25,
						},
					}}
				>
					<Tab label="Key Indicators" sx={tabSx} />
					<Tab label="Financials" sx={tabSx} />
					<Tab label="Fundamentals" sx={tabSx} />
					<Tab label="Market Forecasts" sx={tabSx} />
					<Tab label="News" sx={tabSx} />
					<Tab label="Stock Analyzer" sx={tabSx} />
					<Tab label="Tracked Stocks" sx={tabSx} />
				</Tabs>
			</Box>
			<Box sx={{ padding: "0rem" }}>
				{/* Render the nested route components */}
				<Outlet />
			</Box>
		</>
	);
}
